'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { StytchB2BProvider } from '@stytch/nextjs/b2b';
import { AuthManager } from './AuthManager';
import { getStytchClient } from './client/headless-client';
export function AuthProvider({ children, initialUser, initialWorkspace, initialJWT, enableCache = true, useAuthManager = true, }) {
    const [stytchClient, setClient] = useState(null);
    useEffect(() => {
        setClient(getStytchClient());
    }, []);
    if (!stytchClient)
        return null; // or a tiny loader/spinner
    return (_jsx(StytchB2BProvider, { stytch: stytchClient, children: useAuthManager ? (_jsx(AuthManager, { initialUser: initialUser, initialWorkspace: initialWorkspace, initialJWT: initialJWT, enableCache: enableCache, children: children })) : (children) }));
}
